import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Button } from './Button';
const checkoutUrl = 'https://ballet-teacher-ready.impultienda.ar/checkout';
const frictionPoints = ['No more Sunday nights searching for combinations that actually flow', 'No more classes that feel rushed, repeated, or improvised', 'No more students who plateau because sessions feel the same every week', 'No more weekends lost planning instead of living', 'No more walking into the studio wishing you had prepared more', 'No more recital chaos when there is no system behind you', 'No more guessing whether your students are actually progressing'];
const checklist = ['Volume 1: Ballet Foundations', 'Volume 2: Barre Work System', 'Volume 3: Center Practice & Balance', 'Volume 4: Across-the-Floor & Traveling Steps', 'Volume 5: Jumps, Turns & Strength', 'Volume 6: Complete Ballet Lesson Plans', 'Bonus 1: 100 Ready-to-Teach Ballet Combinations', 'Bonus 2: Ballet Corrections and Teacher Cueing Library', 'Bonus 3: 50 Creative Pre-Ballet Activities', 'Bonus 4: Ballet Recital and Rehearsal Planner', 'Bonus 5: Ballet Progress Tracking and Assessment System', '7-day money-back guarantee', 'Immediate access', 'Pay in your local currency', 'Ready-to-use PDF format'];
function trackCheckout() {
  const fbq = (window as Window & {
    fbq?: (...args: unknown[]) => void;
  }).fbq;
  fbq?.('track', 'InitiateCheckout', {
    content_name: 'Ballet Teacher Ready Complete Teaching Library',
    value: 27,
    currency: 'USD'
  });
}
export function FinalCTA() {
  return <section className="bg-ballet-canvas px-4 py-20 sm:py-28" data-id="element-97" data-mp="34udb36oaz168">
      <div className="mx-auto max-w-4xl" data-id="element-98" data-mp="39sf3wjbj6euw">
        <div className="text-center" data-id="element-99" data-mp="39r3r5u03xwrn">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-ballet-rose" data-id="element-100" data-mp="39u9h1bgk92of">
            Your next teaching week
          </p>
          <h2 className="mt-3 font-display text-5xl font-semibold leading-tight text-ballet-ink" data-id="element-101" data-mp="3isbp2aypovl7">
            Next Monday you can keep building your ballet classes from
            scratch...
            <br data-id="element-102" data-mp="1eps7x7c8zwlt" />
            <span className="text-ballet-rose" data-id="element-103" data-mp="1eqbe5qsjcwk0">
              Or you can walk into the studio with everything ready—from today.
            </span>
          </h2>
          <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-ballet-line bg-white p-7 text-left shadow-card" data-id="element-104" data-mp="1npyjgnodymic">
            <ul className="space-y-3" data-id="element-105" data-mp="22e1r01i2u699">
              {frictionPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-6 text-ballet-muted" data-id="element-106" data-mp="1xg9m86wc2pnn">
                  <span className="text-ballet-gold" data-id="element-107" data-mp="2beq4mv3k64lm">✦</span>
                  {point}
                </li>)}
            </ul>
          </div>
          <p className="mt-10 text-lg text-ballet-muted" data-id="element-108" data-mp="h0yn79ezmgfm">
            Ballet Teacher Ready™ does not make you a better teacher.
          </p>
          <p className="mt-1 font-display text-4xl font-semibold text-ballet-rose" data-id="element-109" data-mp="d1hiii7dxnbi">
            You are already a great teacher.
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-ballet-muted" data-id="element-110" data-mp="6xbirubewd0a">
            What Ballet Teacher Ready™ does is give you the time and the tools
            to make that visible in every single class you teach.
          </p>
        </div>
        <div className="mt-14 rounded-3xl border border-ballet-gold/65 bg-white p-7 shadow-soft sm:p-11" data-id="element-111" data-mp="3u8szln7xxrfy">
          <h3 className="text-center font-display text-4xl font-semibold text-ballet-ink" data-id="element-112" data-mp="3ffhe4dg7fiq6">
            Everything that is included
          </h3>
          <div className="mt-8 grid gap-x-8 gap-y-3 md:grid-cols-2" data-id="element-113" data-mp="36d82fk979jb7">
            {checklist.map(item => <div key={item} className="flex gap-2.5 text-sm leading-6 text-ballet-muted" data-id="element-114" data-mp="3bazymqgvnrl7">
                <CheckCircle2Icon size={17} className="mt-0.5 shrink-0 text-ballet-gold" data-id="element-115" data-mp="14j8u97rdji2q" />
                {item}
              </div>)}
          </div>
          <div className="mt-10 border-y border-ballet-line bg-ballet-blush/45 px-6 py-7 text-center font-display text-2xl italic leading-8 text-ballet-muted" data-id="element-116" data-mp="35l6yedly5lbv">
            “The best time to have this teaching library was before your very
            first ballet class.
            <br data-id="element-117" data-mp="2rn8ktafg9sxf" />
            <strong className="not-italic text-ballet-rose" data-id="element-118" data-mp="2rpusrb696ag6">
              The second best time is today.
            </strong>
            ”
          </div>
          <div className="mt-9 text-center" data-id="element-119" data-mp="2hwxifsbezrsn">
            <p className="font-display text-3xl font-semibold text-ballet-ink" data-id="element-120" data-mp="2hw5m2f9ztq1b">
              Ballet Teacher Ready™
            </p>
            <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-ballet-muted" data-id="element-121" data-mp="280ayr6utr6s7">
              6 complete volumes of ready-to-teach ballet classes—created to
              help ballet teachers plan less, teach with confidence, and keep
              every session technically rich and professionally structured.
            </p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="mt-7" data-id="element-122" data-mp="egae1flqh1f0">
              GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
            <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-ballet-muted" data-id="element-123" data-mp="sguwubrnex8i">
              <span data-id="element-124" data-mp="3rw8czq0j9hox">7-day money-back guarantee</span>
              <span data-id="element-125" data-mp="3rxjhxt5psvhm">Secure payment</span>
              <span data-id="element-126" data-mp="3vxjvzcowj4o5">Immediate access</span>
              <span data-id="element-127" data-mp="3vyd4ai3ie28e">Pay in your local currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}